<template>
  <v-dialog 
    v-model="modal" 
    width="400px"
  >
    <v-card class="mx-auto">
      <v-card-title>{{ $t("Retrieve Study") }}</v-card-title>
      <v-divider></v-divider>

      <v-list two-line subheader class="pb-0">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="grey lighten-1" dark>mdi-download</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ study.patName }}</v-list-item-title>
            <v-list-item-subtitle>{{ study.accessionNo }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="modal = false">{{ $t("close") }}</v-btn>
        <v-btn text color="primary" @click="retrieveStudy">{{ $t("retrieve") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import EventBus from "../../../event-bus";

export default {
  name: "RetrieveModal",
  props: {
    studyData: Object,
  },
  data: () => ({
    modal: false,
    study: {},
  }),
  watch: {
    studyData: function(value) {
      this.study = value.data;
      this.modal = true;
    },
  },
  methods: {
    sendError(error) {
      if (error.response) {
        if (
          error.response.status == 500 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }
    },
    retrieveStudy() {
      axios({
        url: "/api/v1/dicom/retrieve/study",
        method: "POST",
        data: {
          owner: this.$store.getters.username,
          patName: this.study.patName,
          accessionNo: this.study.accessionNo,
          archive: this.study.archive,
          studyIuid: this.study.studyIuid,
        },
      })
        .then((resp) => {
          if (
            !resp.data ||
            !resp.data.status ||
            !(resp.data.status == "done")
          ) {
            this.sendError(resp.data.error);
          } else {
            this.modal = false;

            if (typeof resp.data.jobId === 'undefined') {
              this.sendError("Invalid jobId value.");
            } else {
              this.$emit("onShowJobs");
            }
          }
        })
        .catch((error) => {
          this.sendError(error);
        });
    }
  }
};
</script>

<style scoped>
.v-dialog {
  bottom: 10px !important;
  right: 0 !important;
}
</style>
